import { UnifiedSportEventsListState } from 'src/domains/sportsbook/state/eventsListState/unifiedSportEventsListState/UnifiedSportEventsListState';

export type SportsFilterChipType = 'competition' | 'featured' | 'in-play' | 'outrights';

export type SportsPrimaryFilterId = 'competition' | 'featured' | 'matches' | 'in-play' | 'outrights';

const SPORTS_WITHOUT_OUTRIGHTS_FILTER = new Set(['boxing']);

export const shouldShowOutrightsFilter = (sport: string): boolean => {
    return SPORTS_WITHOUT_OUTRIGHTS_FILTER.has(sport) === false;
};

const DEFAULT_PRIMARY_FILTERS_ORDER: SportsPrimaryFilterId[] = [
    'competition',
    'in-play',
    'featured',
    'matches',
    'outrights',
];

/**
 * Per-sport override of primary filters order.
 * Sports not listed here use DEFAULT_PRIMARY_FILTERS_ORDER.
 */
const PRIMARY_FILTERS_ORDER_BY_SPORT: Partial<Record<string, SportsPrimaryFilterId[]>> = {
    tennis: ['competition', 'matches', 'featured', 'in-play', 'outrights'],
    boxing: ['competition', 'matches', 'featured', 'in-play', 'outrights'],
    mixedmartialarts: ['competition', 'featured', 'in-play', 'matches', 'outrights'],
};

export const getPrimaryFiltersOrder = (eventsListState: UnifiedSportEventsListState): SportsPrimaryFilterId[] => {
    const { sport, inPlayCount, outrightsCount } = eventsListState;
    const order = PRIMARY_FILTERS_ORDER_BY_SPORT[sport] ?? DEFAULT_PRIMARY_FILTERS_ORDER;

    const excludedFilters: Partial<Record<SportsPrimaryFilterId, boolean>> = {
        'in-play': inPlayCount === 0,
        outrights: outrightsCount === 0 || shouldShowOutrightsFilter(sport) === false,
    };

    return order.filter((filterId) => !excludedFilters[filterId]);
};

export { UnifiedSportTimeFilterStrategy } from './strategies/UnifiedSportTimeFilterStrategy';
export { UnifiedSportMarketFilterStrategy } from './strategies/UnifiedSportMarketFilterStrategy';
